import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { GrnItemsInfo } from './grn-items-info.model';
export class GrnDto {
  @ApiProperty()
  @IsNotEmpty({message:"GRN Id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  grnId?: number;

  @ApiProperty()
  @IsNotEmpty({message:"GRN Date should not be empty"})
  @IsAlphanumeric()
  grnDate: Date;

  @ApiProperty()
  @IsNotEmpty({message:"Invoice Date should not be empty"})
  @IsAlphanumeric()
  InvoiceDate: Date;

  @ApiProperty()
  @IsNotEmpty({message:"GRN Numbere should not be empty"})
  @IsAlphanumeric()
  grnNumber?: string;

  @ApiProperty()
  @IsNotEmpty({message:"vendor should not be empty"})
  @IsAlphanumeric()
  vendorId: number;

  @ApiProperty()
  @IsNotEmpty({message:"Invoice Number should not be empty"})
  @IsAlphanumeric()
  invoiceNumber: string;

  @ApiProperty()
  @IsNotEmpty({message:"PO Id should not be empty"})
  @IsAlphanumeric()
  poId: number;

  @ApiProperty()
  @IsNotEmpty({message:"Unit Id Id should not be empty"})
  @IsAlphanumeric()
  unitId: number;

  @ApiProperty()
  @IsNotEmpty()
  saleOrderId: number;
  
  @ApiProperty()
  @IsAlphanumeric()
  totalQuantity: number;

  
  @ApiProperty()
  @IsAlphanumeric()
  totalDiscount: number;

  @ApiProperty()
  @IsAlphanumeric()
  totalTax: number;

 

  @ApiProperty()
  @IsAlphanumeric()
  totalCost: number;

 

  

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  remarks: string;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  approvar: string;

  @ApiProperty()
  @IsAlphanumeric()
  status: string;

  

  @ApiProperty()
  referenceNumber: number;

  
  

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser ?: string;

  
  @ApiProperty({ type: [GrnItemsInfo]})
  grnItemsInfo: GrnItemsInfo[];
  @ApiProperty()
  locationId?: number;
  
}

